<template>
    <div class="mt-5">
        <div class="mt-4 mb-2 is-flex is-justify-content-space-between">
            <p class="has-text-weight-bold" v-if="!isAutomatic">¿Estás seguro que deseas eliminar esta cuenta?</p>
            <p class="has-text-weight-bold" v-if="isAutomatic">¿Estás seguro que deseas desconectar esta cuenta?</p>
            <div>
                <b-button size="is-small" type="is-flow" v-if="!isAutomatic" @click="onConfirmDelete">
                    <div class="is-inline-flex is-align-items-center">
                        <i class="material-icons is-size-6 icon-clear mr-1 mt-1"> delete </i>
                        <span class="mt-1">Si, Eliminar</span>
                    </div>
                </b-button>
                <b-button size="is-small" type="is-flow" v-if="isAutomatic" @click="onConfirmDisconnect">
                    <div class="is-inline-flex is-align-items-center">
                        <i class="material-icons is-size-6 icon-clear mr-1 mt-1"> power_off </i>
                        <span class="mt-1">Si, desconectar</span>
                    </div>
                </b-button>
                <b-button size="is-small" type="is-flow" outlined class="ml-3" @click="onCancel">Mantener</b-button>
            </div>
        </div>
        <p v-if="isAutomatic">Al eliminar tu conexión el saldo de esta cuenta deberá ser actualizado manualmente. Recuerda mantener el saldo de tu cuenta al día, esto permite generar una mejor proyección.</p>
    </div>
</template>

<script>
export default {
    name: "ConfirmMsg",
    props: {
        isAutomatic: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onConfirmDisconnect: function(){this.$emit('on-confirm-disconnect')},
        onConfirmDelete: function(){this.$emit('on-confirm-delete')},
        onCancel: function(){this.$emit('on-cancel')}
    },
};
</script>